module.exports = __webpack_public_path__ + "static/media/minus.3ed45bc6.svg";